import useFlowsActions from "../../../../../hooks/useFlowsActions";
import SelectionButton from "./SelectionButton";
import SplitTest from "./SplitTest";

import type { CampaignFlow } from "../../../../../types";

interface FlowSelectionProps {
  flows: CampaignFlow[];
  selectedIndex: number;
  setSelectedIndex: (selectedFlowIndex: number) => void;
}

export default function FlowSelection({
  flows,
  selectedIndex,
  setSelectedIndex,
}: FlowSelectionProps) {
  const { addFlow, duplicateFlow, deleteFlow } = useFlowsActions(
    flows,
    setSelectedIndex,
  );

  return (
    <div className="my-4 grid grid-cols-2 gap-2 border-b border-b-black-200 pb-3 md:gap-3">
      {flows.length > 1 ? (
        flows.map((flow, index) => (
          <SelectionButton
            key={flow.id}
            flow={flow}
            isSelected={index === selectedIndex}
            onClick={() => setSelectedIndex(index)}
            deleteFlow={deleteFlow}
          />
        ))
      ) : (
        <>
          <SelectionButton flow={flows[0]} isSelected />
          <SplitTest duplicateFlow={duplicateFlow} addFlow={addFlow} />
        </>
      )}
    </div>
  );
}
